module.exports = __webpack_public_path__ + "static/img/thunder@2x.07113917.png";